import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitGrowthMindsetAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitGrowthMindsetAssessmentResultInput;
}>;


export type SubmitGrowthMindsetAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitGrowthMindsetAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitGrowthMindsetAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & GrowthMindsetAssessmentResultFragment
    )> }
  ) }
);

export type GrowthMindsetAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'AitResult' } | { __typename: 'CardioRespResult' } | { __typename: 'DigitSpanResult' } | (
    { __typename: 'GrowthMindsetResult' }
    & GrowthMindsetAssessmentResultDataFragment
  ) | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | { __typename: 'OrganisationalAiReadinessResult' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type GrowthMindsetAssessmentResultDataFragment = (
  { __typename: 'GrowthMindsetResult' }
  & { surveys: Array<(
    { __typename: 'GrowthMindsetSurveyResult' }
    & Pick<SchemaTypes.GrowthMindsetSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & Pick<SchemaTypes.LikertScaleResult, 'score' | 'total' | 'label'>
    ) | (
      { __typename: 'RatingScaleResult' }
      & Pick<SchemaTypes.RatingScaleResult, 'score' | 'minimumValue' | 'maximumValue'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'GrowthMindsetCategoryAverage' }
    & Pick<SchemaTypes.GrowthMindsetCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore' | 'label' | 'description'>
  )>, overallScore: (
    { __typename: 'GrowthMindsetOverallScore' }
    & Pick<SchemaTypes.GrowthMindsetOverallScore, 'maximumPossibleScore' | 'score' | 'label'>
  ) }
);

export const GrowthMindsetAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment GrowthMindsetAssessmentResultData on GrowthMindsetResult {
  surveys {
    category
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        score
        total
        label
      }
      ... on RatingScaleResult {
        score
        minimumValue
        maximumValue
      }
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
    label
    description
  }
  overallScore {
    maximumPossibleScore
    score
    label
  }
}
    `;
export const GrowthMindsetAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment GrowthMindsetAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on GrowthMindsetResult {
      ...GrowthMindsetAssessmentResultData
    }
  }
  createdAt
}
    ${GrowthMindsetAssessmentResultDataFragmentDoc}`;
export const SubmitGrowthMindsetAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitGrowthMindsetAssessmentResult($input: SubmitGrowthMindsetAssessmentResultInput!) {
  submitGrowthMindsetAssessmentResult(input: $input) {
    ... on SubmitGrowthMindsetAssessmentResultSuccessfulResponse {
      result {
        ...GrowthMindsetAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${GrowthMindsetAssessmentResultFragmentDoc}`;
export type SubmitGrowthMindsetAssessmentResultMutationFn = Apollo.MutationFunction<SubmitGrowthMindsetAssessmentResultMutation, SubmitGrowthMindsetAssessmentResultMutationVariables>;

/**
 * __useSubmitGrowthMindsetAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitGrowthMindsetAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGrowthMindsetAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGrowthMindsetAssessmentResultMutation, { data, loading, error }] = useSubmitGrowthMindsetAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGrowthMindsetAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGrowthMindsetAssessmentResultMutation, SubmitGrowthMindsetAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGrowthMindsetAssessmentResultMutation, SubmitGrowthMindsetAssessmentResultMutationVariables>(SubmitGrowthMindsetAssessmentResultDocument, options);
      }
export type SubmitGrowthMindsetAssessmentResultMutationHookResult = ReturnType<typeof useSubmitGrowthMindsetAssessmentResultMutation>;
export type SubmitGrowthMindsetAssessmentResultMutationResult = Apollo.MutationResult<SubmitGrowthMindsetAssessmentResultMutation>;
export type SubmitGrowthMindsetAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitGrowthMindsetAssessmentResultMutation, SubmitGrowthMindsetAssessmentResultMutationVariables>;